import axios from "axios";

export const api = axios.create({
  baseURL: "https://api.teste.agenciacapri.com.br",
});

// export const api = axios.create({
//   baseURL: "http://localhost:8080",
// });
